import store from "./store";
import DataModel from "shared-src/data/DataModel.js";
import MapPosition from "./MapPosition";
import PageFokoModel from "./PageFokoModel";
import MediaImage from "./MediaImage";
import TranslatedObject from "shared-src/data/TranslatedObject";

/**
 * Les données d'une page royaume
 */
export default class PageRoyaumeModel extends DataModel{
    constructor(json) {
        super(json);
        /**
         *
         * @type {TranslatedObject}
         */
        this.titletxt=new TranslatedObject(json.title);
        /**
         * Position du royaume su la carte
         * @type {MapPosition}
         */
        this.mapPosition=new MapPosition(json.mapposition,this);
        /**
         *
         * @type {TranslatedObject}
         */
        this.histoiretxt=new TranslatedObject(json.histoiretxt);
        /**
         *
         * @type {TranslatedObject}
         */
        this.organisationtxt=new TranslatedObject(json.organisationtxt);

        /**
         * Les photos du royaume
         * @type {MediaImage[]}
         */
        this.diaporama=[];
        for(let f of json.diaporama){
            this.diaporama.push(new MediaImage(f));
        }
        /**
         * Les infos relatives aux fokos dans ce royaume et les fokos eux même
         * @type {{txt: TranslatedObject, list: PageFokoModel[]}}
         */
        this.fokos={
            /**
             * @type {TranslatedObject}
             */
            txt:new TranslatedObject(json.fokos.txt),
            map:{
              src:json.fokos.map.src
            },
            /**
             *  @type {PageFokoModel[]}
             */
            list:[]
        };
        for(let f of json.fokos.list){
            let foko=new PageFokoModel(f)
            this.fokos.list.push(foko);
            foko.royaume=this;
        }


    }

    url(lang){
        if(!lang){
            lang=store.state.language;
        }
        return `/${lang}/royaume/${this.id}`;
    }



}
/**
 * Tous les royaumes dans l'ordre
 * @type {PageRoyaumeModel[]}
 */
PageRoyaumeModel.all=[];
